import {i18n} from "@/fit-components/common/lang";

export enum ToastType {
    Tick = 'tick',
}



export function getDefaultConfig() {
    return {
        // title
        type: ToastType.Tick,
        show: false,
        title: i18n('成功'),
        icon: 'tick',
        size: 140
    };
}
